export default function portalAlert(message)
{
    return alert(message);
}